<template>
	<div>
		<el-dialog :close-on-click-modal="false" :visible.sync="isShowHint" center title="提示" top="25vh" width="40%">
			<span style="font-weight: bold; font-size: 1.1em">
				自2023年10月1日起，广东 (注册地)
				企业暂无法投保本方案，可通过以下【广东地区专属方案】进行投保。如有疑问，请及时联系工作人员。
			</span>
			<div style="margin-top: 10px"></div>
			<template slot="footer">
				<div class="u-flex-col u-col-center">
					<el-button style="margin: 5px" type="primary" @click="onChoiceType()">
						太保建筑行业灵活用工保（限广东企业）
					</el-button>
					<el-button style="margin: 5px" type="primary" @click="onChoiceType(1)">
						太保制造行业1-6类雇主险（限广东企业）
					</el-button>
				</div>
			</template>
		</el-dialog>

		<el-dialog
			:close-on-click-modal="false"
			:visible.sync="isShowInsureHint"
			center
			title="提示"
			top="25vh"
			width="40%">
			<div v-if="isXsmJianzhu(currentChoiceData.insureType)" class="insure-hint">
				广东企业灵活用工保的方案，请注意第4项拒保的职业都不保的，请留意本方案：
				1、身故与残疾的情况下出险必须要有安全带及高空等特种作业证，没有其一的话会有25%的免赔；
				2、出险请务必72小时内报案，超时报案免赔50%没有通融的
				3、方案不减员，1个月、3个月保单不能替换，出过险的人员不能替换。 4、伤残使用的是新残标《人体损伤致伤残鉴定标准》
				5、仅门诊治疗没有误工费，出险须到二级及以上公立医院就诊才能赔，医疗社保范围内100%赔付；
				6、1-3类职业不保高空，4-6类职业可保高空。
			</div>
			<div v-else class="insure-hint">
				广东制造行业雇主险的方案，请注意本方案除制造行业的职业都不保的，请留意本方案：
				1、身故与残疾的情况下出险必须要有安全带及高空等特种作业证，没有其一的话会有25%的免赔；
				2、出险请务必72小时内报案，超时报案免赔50%没有通融的； 3、方案只能年保，本方案中途申请退保或批减，可退保费为0；
				4、伤残使用工标十级5%起；
				5、仅门诊治疗没有误工费，出险须到二级及以上公立医院就诊才能赔，医疗社保范围内100%赔付；
				6、1-3类职业不保高空，4-6类职业可保高空； 7、扩展24小时意外医疗，非工作时间死亡伤残赔付不超过投保额的50%；
				8、猝死赔付责任为投保限额的20%； 9、只保工作场所在广东的广东企业。
			</div>
			<template slot="footer">
				<div class="u-flex-row u-row-center">
					<el-button plain="" style="margin: 0 10px" type="primary" @click="isShowInsureHint = false">
						谢谢，投/被保险人不同意此告知
					</el-button>
					<el-button style="margin: 0 10px" type="primary" @click="onChoiceType(3)">投/被保险人均已知悉</el-button>
				</div>
			</template>
		</el-dialog>

		<insure-begin-hint v-if="isShowInsureBegin" ref="showHint"></insure-begin-hint>
	</div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件等等）
// import { mapGetters } from 'vuex'

import InsureBeginHint from '@/views/insurance/product/insureBeginHint.vue'
import {isXsmJianzhu, xsmYinLiuList} from '@/util/productUtil'
import {delEmptyValues, getPageId} from '@/util/commonUtils'
import {setStore} from '@/util/store'
import rrlog from '@meibao/traceback-record'
import {insureMap} from '@/const/crud/insurance/product'

export default {
	name: 'xsmYinLiuDialog',
	mixins: [],
	components: {InsureBeginHint},
	props: {
		interData: {
			type: Object,
			default: () => {
				return {}
			},
		},
	},
	data() {
		return {
			isShowHint: false,
			isShowInsureBegin: false,
			currentChoiceData: {},
			rrlogEventId: null,
			isShowInsureHint: false,
		}
	},
	computed: {
		// ...mapGetters(['userPermissions','buttonType'])
	},
	watch: {},
	methods: {
		isXsmJianzhu,
		showXsmInsuresHint() {
			this.isShowHint = true
		},
		// 0 建筑 1制造，3再次确认
		onChoiceType(type = 0) {
			if (type === 3) {
				this.isShowInsureHint = false
				let {insureType, productId} = this.currentChoiceData
				setTimeout(() => {
					this.isShowInsureBegin = true
					this.$nextTick(() => {
						if (this.$refs.showHint) {
							this.$refs.showHint.showHint(insureType, productId, {})
						}
					})
				}, 250)
				this.rrlogEventId = rrlog.capture(
					`去投保`,
					{
						productId: productId,
						productName: insureMap.get(parseInt(insureType)).name[0],
					},
					{
						sign: true,
					},
				)
			} else {
				this.isShowHint = false
				this.currentChoiceData = xsmYinLiuList[type]
				setTimeout(() => {
					this.isShowInsureHint = true
				}, 250)
			}
		},
		onAgreeInsure() {
			let pageId = getPageId()
			if (this.rrlogEventId) {
				setStore({name: `rrlog_eventid_${pageId}`, content: this.rrlogEventId, type: 'session'})
			}
			let {productId, insureType} = this.currentChoiceData
			//处理数据
			let queryData = Object.assign(this.interData, {insureType, pageId, isYinliu: true})
			this.$router.$avueRouter.closeTag()
			this.$router.push({
				path: this.$router.$avueRouter.getPath({
					src: `/policy/entry/${productId}`,
				}),
				query: delEmptyValues(queryData),
			})

			this.isShowInsureBegin = false
		},
	},
	activated() {
		console.log('xsmYinLiu----activated')
		this.$Bus.$on('onAgreeInsure', this.onAgreeInsure)
	},
	deactivated() {
		console.log('xsmYinLiu----deactivated')
		this.$Bus.$off('onAgreeInsure', this.onAgreeInsure)
	},
	created() {},
	mounted() {},
	updated() {},
	beforeDestroy() {},
	destroyed() {},
	beforeRouteEnter(to, from, next) {
		next()
	},
	beforeRouteUpdate(to, from, next) {
		next()
	},
	beforeRouteLeave(to, from, next) {
		next()
	},
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__body {
	padding: 15px 30px;
}

::v-deep .el-checkbox__label {
	margin-top: 4px;
}

.insure-hint {
	white-space: pre-line;
	font-weight: bold;
}
</style>
